/* Cosy2Road product components. Loaded only by the premium product section. */
(() => {
  if (customElements.get('c2f-product')) return;
  class C2FProduct extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.config = JSON.parse(this.querySelector('[data-c2f-data]').textContent);
      this.form = this.querySelector('[data-c2f-form]');
      this.variant = this.config.variants.find(v => String(v.id) === this.form.elements.id.value) || this.config.variants[0];
      this.form.addEventListener('change', e => this.update(e.target.name === 'id'), options);
      this.form.addEventListener('input', e => { if (e.target.name === 'quantity') this.update(false); }, options);
      this.form.addEventListener('submit', e => this.add(e), options);
      this.querySelectorAll('[data-c2f-thumb]').forEach(button => button.addEventListener('click', () => this.showImage(button.dataset.src, button.dataset.alt, button), options));
      this.thumbs = [...this.querySelectorAll('[data-c2f-thumb]')];
      this.dialog = this.querySelector('[data-c2f-lightbox]');
      this.querySelectorAll('[data-c2f-prev]').forEach(b => b.addEventListener('click', () => this.moveImage(-1), options));
      this.querySelectorAll('[data-c2f-next]').forEach(b => b.addEventListener('click', () => this.moveImage(1), options));
      this.querySelector('[data-c2f-zoom]')?.addEventListener('click', () => { this.syncZoom(); this.dialog.showModal(); }, options);
      this.querySelector('[data-c2f-close]')?.addEventListener('click', () => this.dialog.close(), options);
      this.dialog?.addEventListener('click', e => { if (e.target === this.dialog) this.dialog.close(); }, options);
      this.querySelectorAll('.c2f-stage, .c2f-lightbox').forEach(el => {
        el.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); this.moveImage(e.key === 'ArrowRight' ? 1 : -1); } }, options);
        let touch;
        el.addEventListener('touchstart', e => { const t=e.changedTouches[0]; touch={x:t.clientX,y:t.clientY}; }, {...options, passive:true});
        el.addEventListener('touchend', e => { if (!touch) return; const t=e.changedTouches[0], dx=t.clientX-touch.x, dy=t.clientY-touch.y; if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)*1.5) this.moveImage(dx<0?1:-1); touch=null; }, {...options,passive:true});
      });
      this.updateGallery();
      this.querySelector('[data-c2f-sticky-buy]')?.addEventListener('click', () => this.form.requestSubmit(), options);
      this.observer = new IntersectionObserver(entries => {
        const purchase = entries[0];
        this.querySelector('.c2f-sticky')?.classList.toggle('is-visible', !purchase.isIntersecting && purchase.boundingClientRect.top < 0);
      }, { threshold: 0 });
      this.observer.observe(this.querySelector('.c2f-purchase'));
      this.querySelectorAll('.c2f-tabs a').forEach(a => { a.hidden = !document.getElementById(a.hash.slice(1)); });
      document.querySelectorAll('[data-c2f-final-buy]').forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        if (!this.busy && this.variant?.available) this.form.requestSubmit();
      }, options));
      this.update(false);
      this.updateDelivery();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); clearInterval(this.deliveryInterval); this.controller = null; }
    money(cents) { return new Intl.NumberFormat(this.config.locale || 'fr-FR', { style:'currency', currency:this.config.currency || 'EUR' }).format(cents / 100); }
    selectedExtras() { return [...this.form.querySelectorAll('[data-c2f-extra]:checked')].map(el => ({ id:Number(el.value), price:Number(el.dataset.price) })); }
    updateGallery() {
      const map=this.config.nativeVariants ? {} : (this.config.visuals?.gallery_variants || {});
      this.thumbs.forEach(b => { const ids=map[b.dataset.mediaId]; b.hidden=!!ids?.length && !ids.map(String).includes(String(this.variant.id)); });
      this.visibleThumbs=this.thumbs.filter(b=>!b.hidden);
      this.updateCounter();
    }
    updateCounter() {
      const list=this.visibleThumbs || this.thumbs || [];
      const index=list.findIndex(b=>b.getAttribute('aria-pressed')==='true');
      this.querySelectorAll('[data-c2f-counter]').forEach(e=>e.textContent=`${Math.max(0,index)+1} / ${list.length}`);
    }
    moveImage(direction) {
      const list=this.visibleThumbs || this.thumbs;
      if (!list.length) return;
      let index=list.findIndex(b=>b.getAttribute('aria-pressed')==='true');
      const button=list[(Math.max(0,index)+direction+list.length)%list.length];
      this.showImage(button.dataset.src, button.dataset.alt,button);
      button.scrollIntoView({block:'nearest',inline:'nearest',behavior:'auto'});
    }
    syncZoom() {
      const source=this.querySelector('[data-c2f-main-image]'), target=this.querySelector('[data-c2f-zoom-image]');
      if (source && target) { target.src=source.currentSrc || source.src; target.alt=source.alt; }
    }
    showImage(src, alt, button) {
      if (!src) return;
      const img = this.querySelector('[data-c2f-main-image]');
      img.src = src; img.removeAttribute('srcset'); img.alt = alt || this.config.title;
      button=button || this.thumbs?.find(b=>b.dataset.src === src);
      this.querySelectorAll('[data-c2f-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
      this.updateCounter(); this.syncZoom();
    }
    update(changeImage = true) {
      const id = this.form.elements.id.value;
      const variant = this.config.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.variant = variant;
      const quantityInput = this.form.elements.quantity;
      const quantity = Math.max(1, Math.min(99, Number.parseInt(quantityInput.value, 10) || 1));
      const unitTotal = variant.price + this.selectedExtras().reduce((sum, item) => sum + item.price, 0);
      this.querySelectorAll('[data-c2f-price]').forEach(el => el.textContent = this.money(variant.price));
      this.querySelectorAll('[data-c2f-total]').forEach(el => el.textContent = this.money(unitTotal * quantity));
      const compare = this.querySelector('[data-c2f-compare]');
      if (compare) { compare.hidden = !(variant.compare_at_price > variant.price && this.config.showCompare); compare.textContent = compare.hidden ? '' : this.money(variant.compare_at_price); }
      const savings = this.querySelector('[data-c2f-savings]');
      if (savings) { savings.hidden = compare?.hidden !== false; savings.textContent = savings.hidden ? '' : `${this.config.labels.savings} ${this.money(variant.compare_at_price - variant.price)}`; }
      document.querySelectorAll('[data-c2f-final-price]').forEach(el => el.textContent = this.money(unitTotal * quantity));
      document.querySelectorAll('[data-c2f-final-label]').forEach(el => el.textContent = variant.available ? this.config.labels.add : this.config.labels.soldOut);
      document.querySelectorAll('[data-c2f-final-buy]').forEach(el => el.setAttribute('aria-disabled', String(!variant.available)));
      const stock = this.querySelector('[data-c2f-stock]');
      stock.querySelector('[data-c2f-stock-label]').textContent = variant.available ? this.config.labels.available : this.config.labels.soldOut;
      stock.querySelector('[data-c2f-stock-dispatch]').hidden = !variant.available;
      stock.dataset.available = String(variant.available);
      this.querySelectorAll('[data-c2f-buy]').forEach(el => { el.disabled = !variant.available; el.querySelector('[data-c2f-buy-label]').textContent = variant.available ? this.config.labels.add : this.config.labels.soldOut; });
      const configuration = this.querySelector('[data-c2f-configuration]');
      configuration.textContent = variant.configuration || ''; configuration.hidden = !variant.configuration;
      this.updateGallery();
      this.updateDelivery();
      const packVisual=this.config.visuals?.packs?.[String(variant.id)];
      document.querySelectorAll('[data-c2f-pack-image]').forEach(img=>{ const src=packVisual?.src || variant.image; if(src){img.src=src; img.removeAttribute('srcset');img.alt=packVisual?.alt || variant.label;} });
      if (changeImage && variant.image) this.showImage(variant.image, variant.imageAlt);
      document.querySelectorAll('[data-c2f-variant-specs]').forEach(table => {
        table.replaceChildren();
        table.closest('table').hidden = !(variant.specifications || []).length;
        (variant.specifications || []).forEach(row => {
          const tr = document.createElement('tr'), th = document.createElement('th'), td = document.createElement('td');
          th.scope = 'row'; th.textContent = row.label; td.textContent = row.value; tr.append(th, td); table.append(tr);
        });
      });
      document.querySelectorAll('[data-c2f-pack]').forEach(list => {
        list.replaceChildren();
        list.hidden = !(variant.pack || []).length;
        (variant.pack || []).forEach(text => { const li = document.createElement('li'); li.textContent = text; list.append(li); });
      });
      document.querySelectorAll('[data-c2f-selected-label]').forEach(el => el.textContent = variant.label);
      if (changeImage && this.config.updateUrl) {
        const url = new URL(location.href); url.searchParams.set('variant', String(variant.id)); history.replaceState({}, '', url);
      }
      this.dispatchEvent(new CustomEvent('c2f:variant-change', { bubbles:true, detail:{ variant, quantity, unitTotal } }));
    }
    updateDelivery() {
      this.querySelector('c2f-delivery-module')?.setVariant?.(this.variant);
    }
    async add(event) {
      event.preventDefault();
      if (this.busy || !this.variant?.available || !this.form.reportValidity()) return;
      const message = this.querySelector('[data-c2f-message]'); message.hidden = true; message.textContent = ''; delete message.dataset.success;
      this.busy = true;
      document.querySelectorAll('[data-c2f-final-buy]').forEach(el => { el.setAttribute('aria-busy','true'); el.setAttribute('aria-disabled','true'); });
      const buttons = this.querySelectorAll('[data-c2f-buy]'); buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy','true'); b.querySelector('[data-c2f-buy-label]').textContent = this.config.labels.adding; });
      const quantity = Math.max(1, Math.min(99, Number.parseInt(this.form.elements.quantity.value,10) || 1));
      const ids = [...new Set([Number(this.variant.id), ...this.selectedExtras().map(item=>item.id)])];
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const sections = cart?.getSectionsToRender?.().map(s=>s.id) || ['cart-icon-bubble'];
      const root = this.config.root || '/';
      try {
        const response = await fetch(`${root}cart/add.js`, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify({ items:ids.map(id=>({ id, quantity })), sections, sections_url:location.pathname }) });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.config.labels.error);
        message.hidden = false; message.textContent = this.config.labels.added; message.dataset.success = 'true';
        if (cart?.renderContents) { cart.setActiveElement?.(this.form.querySelector('[name=add]')); cart.classList.remove('is-empty'); cart.renderContents(data); }
        else { location.assign(`${root}cart`); }
      } catch (error) { message.hidden = false; message.textContent = error.message || this.config.labels.error; message.focus(); }
      finally { this.busy = false; document.querySelectorAll('[data-c2f-final-buy]').forEach(el=>{ el.removeAttribute('aria-busy'); el.setAttribute('aria-disabled',String(!this.variant.available)); }); buttons.forEach(b=>{ b.disabled = !this.variant.available; b.removeAttribute('aria-busy'); b.querySelector('[data-c2f-buy-label]').textContent = this.variant.available ? this.config.labels.add : this.config.labels.soldOut; }); }
    }
  }
  customElements.define('c2f-product', C2FProduct);
})();


